import styles from './card.css';
export const inferredObservability = true;
export default class Card extends HTMLElement {
    static get observedAttributes() {
        return [
            'thumbnail',
            'title'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        function getValue(value) {
            return value.charAt(0) === '{' || value.charAt(0) === '[' ? JSON.parse(value) : !isNaN(value) ? parseInt(value, 10) : value === 'true' || value === 'false' ? value === 'true' ? true : false : value;
        }
        if (newValue !== oldValue) {
            switch (name) {
            case 'thumbnail':
                this.thumbnail = getValue(newValue);
                break;
            case 'title':
                this.title = getValue(newValue);
                break;
            }
            this.render();
        }
    }
    selectItem() {
        alert(`selected item is => ${ this.getAttribute('title') }!`);
    }
    connectedCallback() {
        console.log(this);
        if (!this.shadowRoot) {
            console.log('NO ROOT!');
            this.thumbnail = this.getAttribute('thumbnail');
            this.title = this.getAttribute('title');
            this.attachShadow({ mode: 'open' });
            this.render();
        } else {
            console.log('ROOT!');
        }
    }
    render() {
        const {thumbnail, title} = this;
        const template = document.createElement('template');
        template.innerHTML = `<div>
        <style>
          ${ styles }
        </style>
        <h3>${ title }</h3>
        <img src="${ thumbnail }" alt="${ title }" loading="lazy" width="100%">
        <button onclick="this.parentElement.parentNode.host.selectItem()">View Item Details</button>
      </div>`;
        console.log('render');
        if (!this.shadowRoot) {
            console.log(this.shadowRoot);
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));
        } else {
            this.shadowRoot.innerHTML = template.innerHTML;
        }
    }
}
customElements.define('app-card', Card);